import { useEffect } from 'react';
import clsx from 'clsx';
import { AText, Box, Button, Overlay } from '@alf/uikit';
import { LOG_ACTIONS, useLogAmplitude } from '@namespace/analytics';
import { useOtherSettings } from '@namespace/cms';
import {
  SESSION_STORAGE_KEYS,
  setSessionStorageValue
} from '@namespace/helpers';
import { useI18n } from '@namespace/i18n';
import { Icon } from '@namespace/icons2';

import styles from './index.module.css';

export const BonusNotification = ({
  onContinue = () => {},
  onClose = () => {}
}) => {
  const { t } = useI18n();
  const { registrationBonusPopup = {} } = useOtherSettings();
  const logAmplitude = useLogAmplitude();
  const { imagePath } = registrationBonusPopup;

  useEffect(() => {
    logAmplitude({
      actionName: LOG_ACTIONS.REGISTRATION_BONUS_POPUP_SHOW
    });
    setSessionStorageValue(
      SESSION_STORAGE_KEYS.IS_REGISTRATION_BONUS_POPUP_SHOWED,
      true
    );
  }, []);

  return (
    <Overlay
      classNames={{
        wrapperClass: styles.container,
        contentClass: styles.overlayContent
      }}
    >
      <Box
        className={styles.notificationContainer}
        direction="column"
        align="center"
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.closeIcon}>
          <Icon
            size="l"
            name="icons/general/action/close"
            color="btn_close_dark_color"
            onClick={() => {
              logAmplitude({
                actionName: LOG_ACTIONS.REGISTRATION_BONUS_POPUP_STATUS,
                attributes: { status: 'close' }
              });
              onClose();
            }}
          />
        </div>
        <AText
          size="l"
          breed="BU"
          color="txt_color_1"
          align="center"
          className={styles.title}
        >
          {t('register.close.bonuspopup.header')}
        </AText>
        <img
          src={imagePath}
          className={clsx([styles.bonusImage])}
          alt="bonusImage"
        />
        <AText
          size="l"
          breed="B"
          color="txt_color_1"
          align="center"
          className={styles.subtitle}
        >
          {t('register.close.bonuspopup.text1')}
        </AText>

        <AText
          size="s"
          breed="R"
          align="center"
          color="txt_color_1"
          className={styles.text}
        >
          {t('register.close.bonuspopup.text2')}
        </AText>

        <Box justify="center" align="center" className={styles.buttonContainer}>
          <Button
            onClick={() => {
              logAmplitude({
                actionName: LOG_ACTIONS.REGISTRATION_BONUS_POPUP_STATUS,
                attributes: { status: 'continue' }
              });
              onContinue();
            }}
            actionType="color1"
            fullWidth={true}
            size="l"
            intent="primary"
          >
            {t('register.close.bonuspopup.back')}
          </Button>
        </Box>
      </Box>
    </Overlay>
  );
};
